module.exports = __webpack_public_path__ + "img/banner-02.bc79334f.png";